<template>
    <div id="app">
        <keep-alive>
            <!-- 需要缓存的视图组件 -->
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 不需要缓存的视图组件 -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <van-tabbar route class="lyTabbar" v-if="$route.meta.showTabbar">
            <van-tabbar-item replace :to="{ path: '/productsListLy', query: { tags: tags } }">
                <span class="tab-bar-tit">首页</span>
                <img class="tab-bar-img" slot="icon" slot-scope="props" :src="props.active ? homeIcon.active : homeIcon.inactive" />
            </van-tabbar-item>
            <van-tabbar-item replace :to="{ path: '/lyMy' }">
                <span class="tab-bar-tit">我的</span>
                <img class="tab-bar-img" slot="icon" slot-scope="props" :src="props.active ? myIcon.active : myIcon.inactive" />
            </van-tabbar-item>
        </van-tabbar>
        <i v-if="$route.meta.isHomeIcon">
            <img class="backHomeCls" @click="backHomeEvt" src="./assets/backHome.png" alt="">
        </i>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Tabbar, TabbarItem } from 'vant';

    Vue.use(Tabbar).use(TabbarItem);
    export default {
        name: 'App',
        data() {
            return {
                homeIcon: {
                    active: 'https://static.beautyfarm.com.cn/beauty_image/20240614/home_active.png',
                    inactive: 'https://static.beautyfarm.com.cn/beauty_image/20240614/home.png'
                },
                myIcon: {
                    active: 'https://static.beautyfarm.com.cn/beauty_image/20240614/my_active.png',
                    inactive: 'https://static.beautyfarm.com.cn/beauty_image/20240614/my.png'
                },
                tags: window.localStorage.tags
            }
        },
        methods: {
            backHomeEvt() {
                this.$router.push({ path: '/productsListLy', query: { tags: this.tags } })
            }
        }
    }
</script>

<style lang="less">
    @import "./assets/style/style";

    html,
    body {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        margin: 0px;
    }

    #app {
        font-family: Microsoft YaHei;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #343434;
    }

    .lyTabbar {
        height: 80px;
        padding-top: 10px;
    }

    .lyTabbar .van-tabbar-item {
        font-size: 26px !important;
    }

    .lyTabbar .van-tabbar-item .van-icon:before {
        font-size: 34px !important;
    }

    .tab-bar-img {
        width: 50px;
        height: 50px !important;
    }

    .tab-bar-tit {
        font-weight: 400;
        font-size: 20px;
        color: #333F48;
        text-align: center;
    }

    .backHomeCls {
        position: fixed;
        right: 20px;
        top: 1000px;
        width: 80px;
        height: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue